function init(app) {
  if (!app) throw new Error('app is required');
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/filters/index.js